import blocklistedMarkets from './blocklistedMarkets';

const validSortParam = (sortParam) =>
	['distance', 'featured', 'recommended', 'review-rating'].includes(sortParam);

const marketIsBlocklisted = (locationSlug) =>
	blocklistedMarkets.includes(locationSlug);

export const getSortType = (sortParam, locationSlug) => {
	if (sortParam) {
		return validSortParam(sortParam) ? sortParam : null;
	}

	return marketIsBlocklisted(locationSlug) ? 'featured' : 'recommended';
};
